import styles from "./page-statistics.module.scss";

const PageStatistics  = ({items, values})=> {

    const elements = items.map(({id, icon, title, name}) => <div key={id} className={styles.statWrapper}>
        <span className={styles.statIcon}>{icon}</span>
        <div className={styles.statText}>
            <p className={styles.statTitle}>{title}</p>
            <p className={styles.statValue}>{values[name]}</p>
        </div>
    </div>);

    return (
        <div className={styles.statsWrapper}>
            {elements}
        </div>
    )
}

export default PageStatistics;

PageStatistics.defaultProps = {
    items: [],
    values: {}
}
